module.exports = "https://bin.bnbstatic.com/_next/static/images/NPXS_app-EN-2792936bc2ba3c0c8211cd9b9c0123b7.jpg";